import WebView, { WebViewMessageEvent } from 'react-native-webview';
import { Platform, ScrollView, StyleSheet } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { INTEREST_CALCULATOR_URL } from '../../configs/constants';
import InterestCalculatorHeader from './Header/Header';
import { PrivateStackParamList } from '../../navigationApp/types';

//Dynamic imports since Share is not available on web
let Share:any;
import('react-native-share').then(module => {
    Share = module.default;
}).catch(error => {
    console.error('Error loading Share module:', error);
});


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'INTEREST_CALCULATOR'>;


const InterestCalculator = ({navigation} : ScreenProps) => {

  const [showHeader, setShowHeader] = useState(true)
  const containerRef = useRef<ScrollView | null>(null)


  useEffect(() => {
    if (Platform.OS === 'web') {
      window.addEventListener('message', handleIframeMessage);
      // Clean up the event listener when the component unmounts
      return () => {
        window.removeEventListener('message', handleIframeMessage);
      };
    }
  }, [])


  const handleIframeMessage = (event : MessageEvent) => {
    if (
      event?.data?.data &&
      event?.data?.id === 'handleMessageSendOnFullScheduleClick'
    ) {
      const x = event?.data?.data?.position?.x;
      const y = event?.data?.data?.position?.y;
      containerRef?.current?.scrollTo({
        x: parseInt(x),
        y: parseInt(y),
        animated: true,
      });
    }
    if (event?.data?.id === 'IC_INIT_PAGE') {
      setShowHeader(false);
    }
    if (event?.data?.id === 'IC_VIEW_PAGE') {
      setShowHeader(true);
    }
  };

    const handleMessage = (event : WebViewMessageEvent) => {
    if (event?.nativeEvent?.data === 'IC_INIT_PAGE') {
      setShowHeader(false);
      return;
    }
    if (event?.nativeEvent?.data === 'IC_VIEW_PAGE') {
      setTimeout(() => {
        setShowHeader(true);
      }, 750);
      return;
    }
    try {
      const base64Data = event.nativeEvent.data;

      if (base64Data) {
        const shareOptions = {
          title: 'Share PDF',
          url: base64Data,
          type: 'application/pdf',
        };
        // Share?.open(shareOptions);
      }
    } catch (error) {
      console.log('Error', 'Failed to share the PDF', error);
    }
  };


  return (
    <ScrollView ref={containerRef} contentContainerStyle={styles.container}>
      {showHeader && <InterestCalculatorHeader navigation={navigation} />}
      <WebView onMessage={handleMessage} source={{ uri: INTEREST_CALCULATOR_URL }} style={styles.webview} />
    </ScrollView>

  )
}

export default InterestCalculator

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: 'white' },
  webview: {
    flex: 1
  }
})